import { Component, OnInit } from '@angular/core';
declare var $: any;
@Component({
  selector: 'app-blank',
  template: `<app-dot-loader></app-dot-loader>`,
  styles: [``]
})
export class BlankComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    $("#SpinnerDisplay>div").attr("role","presentation")
  }

}
